import React from 'react';
import SectionTitle from '../../components/UI/SectionTitle/index';
import PersonCardsInfo from './PersonCardsInfo';
import serviceTopBg from '../../assets/img/service/service-bg.jpg'

const MiniPersonCard = ({level1, level2, level3}) => {

    return (  
        <div className={`service-area-wrapper sm-top`}>
            {/* <div className="service-area-top" style={{backgroundImage: `url("${serviceTopBg}")`}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-xl-5 m-auto text-center">
                            <SectionTitle variant="light" title="خدمات ما" heading="ما راه پیشرفت شما را هموار می کنیم" />
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="service-content-area">
                <div className="container">
                    <div className='bg-light' style={{width:'100%', display:"flex" , alignItems:'center', justifyContent:'space-around', borderTop:"3px solid red"}}>
                        {
                            level1.map(service=>(
                                <PersonCardsInfo id='1' title={service.displayText} text={service.position.html} thumb={service.image.urls[0]} email={service.email.html}  fax={service.fax.html}  phoneNumber={service.phoneNumber.html} />
                            ))
                        }
                    </div> <div className='bg-light' style={{width:'100%', display:"flex" , alignItems:'center', justifyContent:'space-around'}}>
                        {
                            level2.map(service=>(
                                <PersonCardsInfo id='1' title={service.displayText} text={service.position.html} thumb={service.image.urls[0]}  email={service.email.html}  fax={service.fax.html}  phoneNumber={service.phoneNumber.html} />
                            ))
                        }
                    </div> <div className='bg-light' style={{width:'100%', display:"flex" , alignItems:'center', justifyContent:'space-around'}}>
                        {
                            level3.map(service=>(
                                <PersonCardsInfo id='1' title={service.displayText} text={service.position.html} thumb={service.image.urls[0]}  email={service.email.html}  fax={service.fax.html}  phoneNumber={service.phoneNumber.html} />
                            ))
                        }
                    </div>
                    
                                
                </div>
            </div>
        </div>
    );
}
 
export default MiniPersonCard;